
import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";

export const SafetyMeasuresSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  return (
    <Grid
      md={12}
      xs={12}
      container
      direction={"row"}
      spacing={2}
      sx={{ padding: "0px", paddingTop: "20px", margin: "0px" }}
    >
      <Grid
        md={4}
        xs={12}
        spacing={2}
        sx={{ padding: "0px", paddingRight: "20px" }}
      >
        <Box
          sx={{
            border: "1px solid #DBDBDB",
            borderRadius: "4px",
            padding: "20px",
            height: "100%",
          }}
        >
          <Grid
            sx={{
              backgroundColor: "#63B4FF33",
              color: "#2979C3",
              borderRadius: "10px",
            }}
          >
            <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
              {t("adult-patient-assessment.basic-safety-measures")}
            </ByzMuiTypography>
          </Grid>
          <Stack direction={"column"} sx={{ paddingTop: "20px" }}>
            {[
              {
                name: "safetyMeasures.serviceIntroduced",
                label: "adult-patient-assessment.service-introduced-to-patient",
              },
              {
                name: "safetyMeasures.bedRailsUp",
                label: "adult-patient-assessment.bed-rails-up",
              },
              {
                name: "safetyMeasures.roomIntroduced",
                label: "adult-patient-assessment.room-introduced-to-patient",
              },
              {
                name: "safetyMeasures.bedsideArrangement",
                label: "adult-patient-assessment.bedside-arrangement-completed",
              },
            ].map((measure) => (
              <Stack
                key={measure.name}
                direction={"row"}
                sx={{ paddingTop: "10px" }}
              >
                <Controller
                  name={measure.name}
                  control={control}
                  render={({ field }) => (
                    <ByzMuiCheckBox
                      {...field}
                      checked={!!field.value}
                      onChange={(e) => field.onChange(e.target.checked)}
                    />
                  )}
                />
                <ByzMuiTypography
                  fontWeight={"400"}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  {t(measure.label)}
                </ByzMuiTypography>
              </Stack>
            ))}
          </Stack>
        </Box>
      </Grid>

      <Grid
        md={3}
        xs={12}
        spacing={2}
        sx={{ padding: "0px", paddingRight: "20px" }}
      >
        <Box
          sx={{
            border: "1px solid #DBDBDB",
            borderRadius: "4px",
            padding: "20px",
            height: "100%",
          }}
        >
          <Grid
            sx={{
              backgroundColor: "#63B4FF33",
              color: "#2979C3",
              borderRadius: "10px",
            }}
          >
            <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
              {t("adult-patient-assessment.wristband")}
            </ByzMuiTypography>
          </Grid>
          <Controller
            name="generalMeasures.wristbandInfo"
            control={control}
            render={({ field }) => (
              <ByzMuiRadioButton
                {...field}
                typographyText="adult-patient-assessment.exists-check-info,adult-patient-assessment.not-present-ensure-attachment"
                layout="column"
                border="none"
                fontSize={16}
                textAlign="left"
                maxWidth="100%"
              />
            )}
          />
        </Box>
      </Grid>

      <Grid md={5} xs={12} spacing={2} sx={{ padding: "0px" }}>
        <Stack direction={"row"} spacing={2}>
          <Box
            sx={{
              border: "1px solid #DBDBDB",
              borderRadius: "4px",
              padding: "20px",
              flex: 1,
            }}
          >
            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
                {t("adult-patient-assessment.oxygen-system")}
              </ByzMuiTypography>
            </Grid>
            <Controller
              name="generalMeasures.oxygenSystem"
              control={control}
              render={({ field }) => (
                <ByzMuiRadioButton
                  {...field}
                  typographyText="adult-patient-assessment.open,adult-patient-assessment.close"
                  layout="row"
                  border="none"
                  fontSize={16}
                />
              )}
            />
          </Box>
          <Box
            sx={{
              border: "1px solid #DBDBDB",
              borderRadius: "4px",
              padding: "20px",
              flex: 1,
            }}
          >
            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
                {t("adult-patient-assessment.windows")}
              </ByzMuiTypography>
            </Grid>
            <Controller
              name="generalMeasures.windows"
              control={control}
              render={({ field }) => (
                <ByzMuiRadioButton
                  {...field}
                  typographyText="adult-patient-assessment.open,adult-patient-assessment.close"
                  layout="row"
                  border="none"
                  fontSize={16}
                />
              )}
            />
          </Box>
        </Stack>
        <Stack direction={"row"} spacing={2} sx={{ paddingTop: "20px" }}>
          <Box
            sx={{
              border: "1px solid #DBDBDB",
              borderRadius: "4px",
              padding: "20px",
              flex: 1,
            }}
          >
            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
                {t("adult-patient-assessment.bed-brake")}
              </ByzMuiTypography>
            </Grid>
            <Controller
              name="generalMeasures.bedBrake"
              control={control}
              render={({ field }) => (
                <ByzMuiRadioButton
                  {...field}
                  typographyText="adult-patient-assessment.open,adult-patient-assessment.close"
                  layout="row"
                  border="none"
                  fontSize={16}
                />
              )}
            />
          </Box>
          <Box
            sx={{
              border: "1px solid #DBDBDB",
              borderRadius: "4px",
              padding: "20px",
              flex: 1,
            }}
          >
            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
                {t("adult-patient-assessment.companion-requirement")}
              </ByzMuiTypography>
            </Grid>
            <Controller
              name="generalMeasures.companionRequirement"
              control={control}
              render={({ field }) => (
                <ByzMuiRadioButton
                  {...field}
                  typographyText="adult-patient-assessment.open,adult-patient-assessment.close"
                  layout="row"
                  border="none"
                  fontSize={16}
                />
              )}
            />
          </Box>
        </Stack>
      </Grid>
    </Grid>
  );
};
